import SitePreview from './SitePreview';
import stile from './Projects.module.css';
import { useSprache } from '../sprache';

function Projects({ isOpen, setIsOpen }) {
  const { sprache, t } = useSprache();

  // Liste ausgewählter Web- und Softwareprojekte
  const projektListe = [
    {
      url: 'github.com/kalatyn/photo-batch-renamer/releases',
      name: 'Photo Batch Renamer',
      about: {
        de: 'Benennt Kamerafotos von Standardnamen in eigene Namen um: DSC0001.JPG → Dein Name_1.jpg. Kostenlose Desktop-App für Windows, macOS und Linux mit Live-Vorschau, Sortierung nach Aufnahmedatum (EXIF) und Rückgängig-Funktion.',
        en: 'Renames camera photos from default names to your own: DSC0001.JPG → Your Name_1.jpg. Free desktop app for Windows, macOS and Linux with live preview, sorting by capture date (EXIF) and undo.',
      },
      techs: { de: 'Python / PySide6 (Qt) / EXIF / Desktop-App', en: 'Python / PySide6 (Qt) / EXIF / Desktop App' },
      git: 'https://github.com/kalatyn/photo-batch-renamer',
      vorschaubild: './img/photo-batch-renamer.webp',
      linkText: 'Download',
    },
    {
      url: 'rodnayarech.de',
      name: 'Rodnaya Rech',
      about: {
        de: 'Mehrsprachige Website (RU/DE/EN) für individuellen Online-Russischunterricht für Kinder, die in Deutschland aufwachsen.',
        en: 'Multilingual website (RU/DE/EN) for individual online Russian lessons for children growing up in Germany.',
      },
      techs: { de: 'Next.js / React / Mehrsprachigkeit (i18n)', en: 'Next.js / React / Multilingual (i18n)' },
      vorschaubild: './img/rodnayarech.webp',
    },
    {
      url: 'gigashift.kalakutok.com',
      name: 'Gigashift',
      about: {
        de: 'Automatisierte KI-Nachrichtenplattform (KI-Newsportal), die aktuelle IT- und Technologie-Nachrichten mithilfe künstlicher Intelligenz vollautomatisch aggregiert, analysiert und aufbereitet.',
        en: 'Automated AI news platform that aggregates, analyses and prepares current IT and technology news fully automatically using artificial intelligence.',
      },
      techs: { de: 'Next.js / React / KI (LLMs) / Automation / Node.js', en: 'Next.js / React / AI (LLMs) / Automation / Node.js' },
      isBeta: true,
      vorschaubild: './img/gigashift.webp',
    },
    {
      url: 'www.quantoloop.com',
      name: 'Quantoloop',
      about: {
        de: 'Unternehmens-Website mit interaktiven Komponenten, erstellt während meines Praktikums bei Quantaloop.',
        en: 'Company website with interactive components, built during my internship at Quantaloop.',
      },
      techs: { de: 'HTML5 / CSS3 / Vanilla JavaScript', en: 'HTML5 / CSS3 / Vanilla JavaScript' },
      vorschaubild: './img/quantoloop.webp',
    },
    {
      url: 'my-project-react-taupe.vercel.app',
      name: 'All-in-One Dashboard App',
      about: {
        de: 'Interaktive Web-Applikation mit Aufgabenverwaltung, Musik-Player und Wetterbericht auf Basis von React.',
        en: 'Interactive React web application with task management, a music player and a weather forecast.',
      },
      techs: { de: 'React / JavaScript / CSS-Module / REST-APIs', en: 'React / JavaScript / CSS Modules / REST APIs' },
      git: 'https://github.com/kalatyn/my_web_app_NEXT_JS-main',
      vorschaubild: './img/dashboard.webp',
    },
    {
      url: 'my-project-tetris.vercel.app',
      name: 'Retro Tetris Web Game',
      about: {
        de: 'Klassisches Arcade-Tetris-Spiel im modernen Webformat mit flüssiger Spiellogik und Highscore-Tracking.',
        en: 'Classic arcade Tetris in a modern web format with smooth game logic and high-score tracking.',
      },
      techs: { de: 'JavaScript / React / Canvas / CSS3', en: 'JavaScript / React / Canvas / CSS3' },
      git: 'https://github.com/kalatyn/my-project-Tetris',
      vorschaubild: './img/tetris.webp',
    },
  ];

  return (
    <section className={`${stile.projectsSection} scrollEnthuellung`} id="projects">
      <div className={stile.titelContainer}>
        <span className="abschnittsNummer">[02] {t('nav.projekte')}</span>
        <h2 className={stile.mainTitle}>{t('projekte.titel')}</h2>
        <p className={stile.subTitle}>
          {t('projekte.untertitel')}
        </p>
      </div>

      <div className={stile.projectsContainer}>
        {projektListe.map((projekt, index) => (
          <div key={index}>
            <SitePreview
              url={projekt.url}
              name={projekt.name}
              about={projekt.about[sprache]}
              techs={projekt.techs[sprache]}
              git={projekt.git}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              isBeta={projekt.isBeta}
              vorschaubild={projekt.vorschaubild}
              linkText={projekt.linkText}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Projects;
